import { View } from 'react-native';

import { PrimaryButton } from '@/components/atoms';
import { useTranslation } from '@/i18n';

interface SignOutCardProps {
  onSignOut: () => void;
}

export const SignOutCard = ({ onSignOut }: SignOutCardProps) => {
  const { t } = useTranslation();

  return (
    <View>
      <PrimaryButton onPress={onSignOut} testID="settings-logout-button">
        {t('settings.logOutButton')}
      </PrimaryButton>
    </View>
  );
};
